import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { FloatingActions } from "@/components/FloatingActions";
import { Contact } from "@/components/Contact";
import { SaloonHero } from "@/components/salon/SaloonHero";
import { Standards } from "@/components/salon/Standards";
import { Services } from "@/components/salon/Services";
import { Reviews } from "@/components/salon/Reviews";

export default function SaloonPage() {
  return (
    <div className="bg-slate-950 text-slate-100 font-sans antialiased selection:bg-rose-500 selection:text-white min-h-screen" data-testid="saloon-page">
      <SiteHeader brand="saloon" />
      <SaloonHero />
      <Standards />
      <Services />
      <Reviews />
      <Contact />
      <SiteFooter brand="saloon" />
      <FloatingActions />
    </div>
  );
}
